import { RouteConfig } from "vue-router";
import StaffOverview from "@/views/staff_survey/overview/Overview.vue";
import FormList from "@/views/staff_survey/form_generator/FormList.vue";
import QuestionList from "@/views/staff_survey/form_generator/Question.vue";
import Summary from "@/views/staff_survey/summary/Summary.vue";
import StaffOverviewDetails from "@/views/staff_survey/overview/OverviewDetails.vue";

const routes: Array<RouteConfig> = [
  {
    path: "overview",
    components: {
      default: StaffOverview,
      overview: StaffOverview,
      details: StaffOverviewDetails,
      summary: Summary,
      Forms: FormList,
      Questions: QuestionList,
    },
    meta: {
      title: "Overview",
      requiresAuth: true,
    },
  },
  {
    path: "overview/details",
    components: {
      default: StaffOverviewDetails,
      overview: StaffOverview,
      details: StaffOverviewDetails,
      summary: Summary,
      Forms: FormList,
      Questions: QuestionList,
    },
    meta: {
      title: "Overview Details",
      requiresAuth: true,
    },
  },
  {
    path: "summary",
    components: {
      default: Summary,
      overview: StaffOverview,
      details: StaffOverviewDetails,
      summary: Summary,
      Forms: FormList,
      Questions: QuestionList,
    },
    meta: {
      title: "Summary",
      requiresAuth: true,
    },
  },
  {
    path: ":slug/form",
    components: {
      default: FormList,
      overview: StaffOverview,
      details: StaffOverviewDetails,
      summary: Summary,
      Forms: FormList,
      Questions: QuestionList,
    },
    meta: {
      title: "Discharge Form List",
      requiresAuth: true,
    },
  },
  {
    path: ":slug/form/:formId/question",
    components: {
      default: QuestionList,
      overview: StaffOverview,
      details: StaffOverviewDetails,
      summary: Summary,
      Forms: FormList,
      Questions: QuestionList,
    },
    meta: {
      title: "Discharge Questions",
      requiresAuth: true,
    },
  },
];

export default routes;
